import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamQuery } from "../graphql/queries";
import type {
  StreamQueryType,
  StreamQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamQuery = (
  options?: QueryHookOptions<StreamQueryType, StreamQueryVariablesType>
) => {
  return useQuery<StreamQueryType, StreamQueryVariablesType>(
    StreamQuery,
    options
  );
};
